import React from 'react';
import PropTypes from 'prop-types';

const ClockOut = ({ stopTime, cancel }) => {
  return (
    <div className="c-inner-wrapper u-max-width-400 u-position-relative u-mt+ large-and-up-mt++">
      <h2 className="u-mb">
        Clock out
      </h2>
      <button
        className="c-btn u-mr u-mb"
        onClick={stopTime}
      >
        Clock Out and Log out
      </button>
      <button
        className="c-btn"
        onClick={cancel}
      >
        Just Log out
      </button>
    </div>
  );
};

ClockOut.propTypes = {
  stopTime: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
};

export default ClockOut;
